import { useContext, useEffect, useState } from "react";
import { IPackage } from "../../../types/global";
import FeaturedTrekkingCard from "../../cards/FeaturedTrekkingCard";
import LangContext from "../../../context/LangContext";
import PackagesService from "../../../services/Packages.service";

const FeaturedPackages = () => {
  const [data, setData] = useState<IPackage[]>([]);
  const { lang_id } = useContext(LangContext);
  const fetchFeaturedPkgs = async () => {
    try {
      const res = (await PackagesService.fetchPackages(
        "",
        lang_id,
        true
      )) as any;
      console.log(res);
      setData(res.data.data[0]);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (lang_id) {
      fetchFeaturedPkgs();
    }
  }, [lang_id]);
  return (
    <div className="mb-10 container mx-auto px-4 lg:px-8">
      <div className=" my-16 prose text-left">
        <h1 className="text-left">
          <span className="text-primary-base">Featured</span> Trekking Routes{" "}
        </h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {data.map((item, i) => (
          <FeaturedTrekkingCard
            key={i}
            id={item.id}
            img={item.package_img}
            tekkingTitle={item.translation[0]?.package_title}
            day={item.day}
            night={item.night}
          />
        ))}
      </div>
    </div>
  );
};

export default FeaturedPackages;
